import { Box, Divider, Typography, Avatar, Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useState, useCallback, useEffect } from "react";
import { getInvoiceData } from "../../features/invoice/invoiceSlice";
import { getPolicy } from "../../features/policy/policySlice";
import { getPharmacyImage } from "../../utils/utils";
import InvoiceTable from "./invoiceTable";
import AppButton from "../common/AppButton";
import CustomerDetailsInvoiceTable from "./customerDetailInvoiceTable";
import DownloadIcon from "../IconComp/download";

const headerData = ["Invoice", "Total Amt", "Discount", "Paid", "Due"];

export const CustomerDetailsInvoice = ({
  invoiceId,
  selectedInstructions,
  onClose,
  onSaveAndClose,
  isPrint,
  handleCloseEditFunction,
  allInvoices,
  paidAmount,
  dueAmount,
  receiveOnInvoice,
}: any) => {
  const dispatch = useAppDispatch();
  const profiledata: any = useAppSelector(
    (state: any) => state.profile.profileDetails
  );
  const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
  const [tableRowData, setTableRowData] = useState<any[]>([]); // Initialize as an empty array
  const [rowData, setRowData] = useState<any>();
  const pharmacyId = localStorage?.getItem("pharmacyId") || "";

  const customerInvoiceData = allInvoices[0];

  const imageTimestamp = Date.now();

  if (invoiceId) {
  }
  const GetPolicy = useCallback(() => {
    dispatch(getPolicy(pharmacyID));
  }, [dispatch, pharmacyID]);
  useEffect(() => {
    if (pharmacyID) GetPolicy();
  }, [pharmacyID, GetPolicy]);
  const { policyPayload }: any = useAppSelector((state) => state.policy);

  const getInvoice = useCallback(async () => {
    if (invoiceId) {
      const obj = {
        pharmacy_id: pharmacyId,
        invoice_id: invoiceId,
      };
      try {
        const res: any = await dispatch(getInvoiceData(obj));

        if (res?.payload) {
          setRowData(res?.payload);
        }
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      }
    }
  }, [dispatch, invoiceId, pharmacyId]);

  useEffect(() => {
    getInvoice();
  }, [getInvoice]);

  useEffect(() => {
    if (customerInvoiceData?.invoices?.length > 0) {
      const mappedData = customerInvoiceData?.invoices?.map((invoice: any) => ({
        Invoice: invoice.id ?? "-",
        "Total Amt": invoice.total_Amount || 0,
        Discount: `${invoice?.discount_Amount || 0} (${
          invoice?.discount_percentage || 0
        }%)`,
        Paid: invoice.paid_amount || 0,
        Due: invoice.due_amount || 0,
      }));

      setTableRowData(mappedData);
    } else {
      setTableRowData([]);
    }
  }, [customerInvoiceData]);

  // Convert ISO date string to a formatted date

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const date =
    customerInvoiceData?.created_at &&
    formatDate(customerInvoiceData?.created_at);
  const time =
    customerInvoiceData?.created_at &&
    new Date(customerInvoiceData?.created_at).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  const latestInvoice = customerInvoiceData?.payments
    ?.slice()
    ?.sort(
      (a: any, b: any) =>
        new Date(b.paid_at).getTime() - new Date(a.paid_at).getTime()
    )[0];

  const paymentDate =
    latestInvoice?.paid_at &&
    new Date(latestInvoice.paid_at).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

  const paymentTime =
    latestInvoice?.paid_at &&
    new Date(latestInvoice.paid_at).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });

  const pharmacyName = customerInvoiceData?.pharmacy?.name;
  const pharmacyAddress = customerInvoiceData?.pharmacy?.address?.address;
  const licenseNo =
    customerInvoiceData?.pharmacy?.pharmacy_auth?.license_number;
  const userName = rowData?.add_by_admin ? "Admin" : rowData?.created_by?.name;

  const customerName = customerInvoiceData?.name;
  const customerPhoneNumber = customerInvoiceData?.phone_number;
  const latestPayment = customerInvoiceData?.payments
    ?.slice() // to avoid mutating the original array
    ?.sort(
      (a: any, b: any) =>
        new Date(b.paid_at).getTime() - new Date(a.paid_at).getTime()
    )[0];

  const paymentStatus = latestPayment?.payment_type;

  // Create a set to store unique purchased items
  const purchasedItems = new Set();

  // Iterate over tableRowData to add each unique purchased item to the set
  tableRowData?.forEach((item: any) => {
    purchasedItems?.add(item["Purchased Item"]);
  });

  const totalAmount = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr["Total Amt"],
    0
  );
  const totalDiscount = tableRowData?.reduce((acc: number, curr: any) => {
    const match = String(curr.Discount).match(/^(\d+(\.\d+)?)/); // match first number
    const amount = match ? parseFloat(match[0]) : 0;
    return acc + amount;
  }, 0);
  const totalPaid = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr.Paid,
    0
  );
  const totalDue = tableRowData?.reduce(
    (acc: any, curr: any) => acc + curr.Due,
    0
  );

  const hasDiscountPercentagePrevious = tableRowData?.some(
    (entry: any) => entry?.Discount
  );

  const handleSaveInvoice = () => {
    onClose(); // Close the modal
    onSaveAndClose();
    if (typeof handleCloseEditFunction === "function") {
      handleCloseEditFunction(); // Only call if function exists
    }
    localStorage?.removeItem("salesData");
  };

  const handleSaveAndPrintInvoice = () => {
    onClose(); // Close the modal
    onSaveAndClose();
    if (typeof handleCloseEditFunction === "function") {
      handleCloseEditFunction(); // Only call if function exists
    }
    localStorage?.removeItem("salesData");
    window?.print(); // Trigger print dialog
  };

  const handlePrintOnly = () => {
    onClose(); // Close the modal
    onSaveAndClose();
    window?.print();
  };
  const paymentTypeLabels: any = {
    0: "Jazz Cash",
    1: "Easy Paisa",
    2: "Bank Card",
    3: "Cash",
    4: "Other",
    5: "Bank Transfer",
  };
  return (
    <>
      <style>
        {`
      @media print {
        @page {
          margin: 0; /* Removes the default margin that may add header and footer */
        }
        body {
          margin: 1cm; /* Adjust the margin as needed */
        }
        header, footer {
          display: none; /* Hides any header or footer content */
        }
      }
    `}
      </style>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            fontWeight: 600,
            fontSize: "35px",
            padding: "7px",
            lineHeight: "38px",
          }}
        >
          {pharmacyName}
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 400,
            fontSize: "27px",
            lineHeight: "32px",
            padding: "7px",
          }}
        >
          {pharmacyAddress}
        </Box>
        <Divider sx={{ borderColor: "black" }} />
        <Box
          sx={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: "27px",
            lineHeight: "32px",
            padding: "7px",
          }}
        >
          Invoices Information
        </Box>
        <Divider sx={{ borderColor: "black" }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            textAlign: "center",
            fontWeight: 400,
            fontSize: "20px",
            lineHeight: "25px",
            mt: "5px",
            padding: "5px",
            wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          <Box>
            {" "}
            <Box component="span" sx={{ fontWeight: 600 }}>
              Customer Name:
            </Box>{" "}
            {customerName}
          </Box>
          <Box>
            {" "}
            <Box component="span" sx={{ fontWeight: 600 }}>
              Number:
            </Box>{" "}
            {customerPhoneNumber}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            textAlign: "center",
            fontWeight: 400,
            fontSize: "20px",
            lineHeight: "25px",
            mt: "5px",
            padding: "5px",
            wordWrap: "break-word", // Ensure text wraps within the box
          }}
        >
          <Box>
            <Box component="span" sx={{ fontWeight: 600 }}>
              Date:
            </Box>{" "}
            {date}
          </Box>
          <Box>
            <Box component="span" sx={{ fontWeight: 600 }}>
              Created By:
            </Box>{" "}
            {userName}
          </Box>
        </Box>
      </Box>

      <Box sx={{ mt: 3, width: "100%" }}>
        <CustomerDetailsInvoiceTable
          headerData={headerData}
          rowData={tableRowData}
          totalAmount={totalAmount}
          totalDiscount={totalDiscount}
          totalPaid={totalPaid}
          totalDue={totalDue}
          isPrint={isPrint}
        />
      </Box>

      <Divider />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          fontWeight: 500,
          fontSize: "20px",
          lineHeight: "25px",
          mt: 3,
          bgcolor: "#F7F9FA",
          borderRadius: "16px",
          padding: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Amount</Box>
          <Box marginLeft={1}>
            Rs.{" "}
            {Math.round(totalAmount).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Total Discount</Box>
          <Box marginLeft={1}>
            Rs.{" "}
            {Math.round(totalDiscount).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Total Received</Box>
          <Box marginLeft={1}>
            Rs.{" "}
            {Math.round(receiveOnInvoice).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Remaining Dues</Box>
          <Box marginLeft={1}>
            Rs.{" "}
            {Math.round(dueAmount).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Payment Method</Box>
          <Box marginLeft={1}>
            {paymentTypeLabels[paymentStatus] ?? "Unknown"}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>Payment Time</Box>
          <Box marginLeft={1}>
            {paymentDate}, {paymentTime}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Button
          onClick={handleSaveAndPrintInvoice}
          startIcon={<DownloadIcon />}
          sx={{
            mt: 2,
            textTransform: "none",
            color: "#0055A8", // bright blue
            backgroundColor: "transparent",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline",
            },
            fontWeight: 500,
            fontSize: "14px",
            minWidth: "auto",
            padding: 0,
            "@media print": {
              display: "none", // Hide this section when printing
            },
          }}
        >
          Get Receipt
        </Button>
      </Box>
    </>
  );
};
